import React from "react";

import { odooTagColor } from "@/utils/odooFormat";

export default function TrackingTagBadge({ name, color }) {
  const bg = odooTagColor(color);
  return (
    <span
      className="inline-flex items-center rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-wide text-white"
      style={{ backgroundColor: bg }}
    >
      {name}
    </span>
  );
}
